import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { map, reduce } from 'lodash';

import {
	storageStackedUnitBuckets,
	vehicleStackedUnitBuckets,
} from 'config/units';

import StackedUnit from './NewStackedUnit';

export function emptyStorageUnit(size) {
	const unit = {
		quantity: 0,
		placeholder: true,
	};
	switch (size) {
		case 'largeUnit':
			unit.size = "10' x 10'";
			break;
		case 'mediumUnit':
			unit.size = "5' x 10'";
			break;
		default:
			unit.size = "5' x 5'";
	}

	return unit;
}

export function StackedUnitsList({
	facility,
	units,
	storageType,
	searchParams,
	baseUrl,
}) {
	const { stackedUnits, facilityId } = useMemo(() => {
		let stacked = [];
		if (storageType === 'vehicle') {
			// Grab the first 3 available vehicle buckets
			stacked = reduce(
				vehicleStackedUnitBuckets,
				(stack, bucket) =>
					units[bucket] ? [...stack, units[bucket]] : stack,
				[],
			).slice(0, 3);
			if (searchParams.length) {
				stacked = stacked.filter((unit) => {
					const rangeLength = searchParams.length.split('-');
					const unitLength = Number.parseFloat(unit.length);
					return (
						unitLength >= Number.parseFloat(rangeLength[0]) &&
						unitLength <= Number.parseFloat(rangeLength[1])
					);
				});
			}
		} else {
			stacked = map(storageStackedUnitBuckets, (size) => {
				if (searchParams?.sqft) {
					if (!units[size]) return units[size];
					const rangeSQFT = searchParams.sqft.split('-');
					const sqft = units[size].squareFootage;
					if (
						sqft >= Number(rangeSQFT[0]) &&
						sqft <= Number(rangeSQFT[1])
					) {
						return units[size];
					}
					return null;
				}
				return units[size] || emptyStorageUnit(size);
			});
		}
		return {
			stackedUnits: stacked,
			unitsAvailable: units.unitsAvailable,
			moreUnitsText: units.moreUnitsText,
			facilityId: facility.id,
			facilityUrl: facility.url,
			facility,
		};
	}, [units, storageType, facility, searchParams]);

	return (
		<div className="new-clp-stacked-units">
			{stackedUnits.map(
				(unit, index) =>
					unit && (
						<StackedUnit
							key={unit.id || `${facilityId}-${index}`}
							facilityId={facilityId}
							unit={unit}
							facility={facility}
							baseUrl={baseUrl}
						/>
					),
			)}
		</div>
	);
}

StackedUnitsList.propTypes = {
	facility: PropTypes.object.isRequired,
	units: PropTypes.object.isRequired,
	storageType: PropTypes.string,
	searchParams: PropTypes.object,
	baseUrl: PropTypes.string,
};

export default StackedUnitsList;
